<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              国家地区：
              <el-select
                v-model="searchData.country_id"
                title="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in constDict.country_list"
                  :key="option.id"
                  :label="option.value"
                  :value="option.id"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              角色搜索：
              <el-select
                v-model="searchData.roleid"
                @change="clearTeacher"
                clearable>
                <el-option
                  v-for="item in constDict.roleids"
                  :key="item.roleid"
                  :label="item.name"
                  :value="item.roleid"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              咨询老师：
              <el-select
                v-model="searchData.teacher_id"
                title="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in optionTeacherList"
                  :key="option.key"
                  :label="option.name"
                  :value="option.key"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              转化时间：
              <el-date-picker
                v-model="searchData.timeline"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="8">
              排序：
              <el-select v-model="searchData.sort" title="请选择" filterable clearable>
                <el-option key="count_all" label="资源数" value="count_all"/>
                <el-option key="sign_month" label="实际签约数" value="sign_month"/>
                <el-option key="sign_p" label="实际转化率" value="sign_p"/>
                <el-option key="sign_month_real" label="当期签约数" value="sign_month_real"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              推广人：
              <el-select
                filterable
                multiple
                v-model="searchData.custom_promoter"
                clearable
                placeholder="请选择">
                <el-option-group
                  v-for="(group, k) in constDict.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="option in group"
                    :key="option.userid"
                    :label="option.username"
                    :value="option.userid"/>
                </el-option-group>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              是否直播:
              <jm-dict-select
                class="jm-input-common"
                v-model="searchData.liveStatus"
                type="dataset"
                name="liveStatus"
                dict-type="student"
                clearable/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="searchBottom">
              <el-button type="primary" class="jm-input-common3" @click="doSearch()">搜索</el-button>
            </el-col>
          </el-row>
          <div class="channel-list2020">
            <p>
              数据说明
              <el-tooltip
                placement="right"
                effect="light">
                <div slot="content">
                  2023.04.11
                  <ul>
                    <li>资源数：资源当前顾问对应的资源数。</li>
                  </ul>
                </div>
                <i class="el-icon-question blue"/>
              </el-tooltip>
            </p>
            <el-row class="list-title">
              <el-col :span="5">渠道名</el-col>
              <el-col :span="2">资源数</el-col>
              <el-col :span="2">星图拉取数</el-col>
              <el-col :span="3">公海资源数</el-col>
              <el-col :span="3">实际签约数</el-col>
              <el-col :span="3">实际转化率</el-col>
              <el-col :span="3">当期签约数</el-col>
              <el-col :span="2">星图拉取签约数</el-col>
            </el-row>
            <data-list :url="url"
                       @tapEvent="showChannelInfo"
                       :search-data="searchData"
                       :refresh.sync="refresh"
                       :refresh-lock="true">
              <template slot-scope="{ item }">
                <el-row class="channel-list-level channel-list-level1">
                  <el-col class="ib" :span="5"><span><i :class="item.show ? 'active' : ''" v-if="item.list"></i>{{ item.channel_name }}</span></el-col>
                  <el-col class="ib" :span="2">{{ item.count_all }}</el-col>
                  <el-col class="ib" :span="2">{{ item.pull }}</el-col>
                  <el-col class="ib" :span="3">{{ item.water }}</el-col>
                  <el-col class="ib" :span="3">{{ item.sign_month_real }}</el-col>
                  <el-col class="ib" :span="3">{{ item.sign_p }}</el-col>
                  <el-col class="ib" :span="3">{{ item.sign_month }}</el-col>
                  <el-col class="ib" :span="2">{{ item.pullsign }}</el-col>
                </el-row>
                <div v-show="item.show" v-if="item.list">
                  <el-row class="channel-list-level channel-list-level2" v-for="ii in item.list" :key="ii.custom_from_sub">
                    <el-col class="ib" :span="5"><span>{{ ii.channel_name_str !== '' ? ii.channel_name_str : ii.custom_from_sub }}</span></el-col>
                    <el-col class="ib" :span="2">{{ ii.count_all }}</el-col>
                    <el-col class="ib" :span="2">{{ ii.pull }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.water }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.sign_month_real }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.sign_p }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.sign_month }}</el-col>
                    <el-col class="ib" :span="2">{{ ii.pullsign }}</el-col>
                  </el-row>
                </div>
              </template>
            </data-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiBarLine from '@/components/charts/biBarLine';
import { getAdvisoryTeachers } from '@/api/teacher';
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';
import dataList from '@/pages/h5/compoments/dataList';
import { formatSelectGroupData } from '@/utils/utils.js';
import * as moment from 'moment';

let constDict = {
  year: ['全部'],
  month: ['全部', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      refresh: false,
      searchData: {
        gid: '',
        teacher_id: [],
        custom_promoter: [],
        timeline: [],
        roleid: '',
        sort: 'count_all',
        country_type: '',
        country_id: []
      },
      url: '/index/bi.channel/getChannelPage',
    };
  },
  components: {
    BiBarLine, getAdvisoryTeachers, jmChannel, jmTableList, dataList
  },
  created() {
    this.$http
      ._get({
        url: '/index/bi.channel/searchDs'
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        this.constDict.create_person = formatSelectGroupData(this.constDict.create_person);
        delete this.constDict.create_person.ZZ;
        this.searchData.roleid = typeof this.constDict.roleids === 'object' ? this.constDict.roleids[0].roleid : this.constDict.roleids;
        this.initSearchTime();
        this.doSearch();
      });
  },
  methods: {
    doSearch() {
      this.refresh = true;
    },
    showChannelInfo(item) {
      item.show = !item.show;
    },
    filterTeacher(option) {
      let group = (this.searchData.gid && this.searchData.gid === option.group_id) || !this.searchData.gid;
      // let roleid = (this.searchData.roleid && this.searchData.roleid === option.role_id) || !this.searchData.roleid;
      return group;
    },
    initSearchTime() {
      this.searchData.timeline = [
        `${moment().format('YYYY-MM')}-01`,
        moment().format('YYYY-MM-DD')
      ];
    },
    clearCountry() {
      this.searchData.country_id = [];
    },
    clearTeacher() {
      this.searchData.teacher_id = [];
    },
    clearGroupTeacher() {
      this.searchData.gid = '';
      this.clearTeacher();
      this.searchData.country_type = '';
      this.clearCountry();
    }
  },
  computed: {
    optionGroupList() {
      return this.constDict.group_list.filter((option) => {
        return this.searchData.roleid === option.group_role_id;
      });
    },
    optionTeacherList() {
      if (this.constDict.teacher) {
        return this.constDict.teacher.filter((option) => {
          return this.filterTeacher(option);
        });
      }
      return [];
    },
    optionCountryTypeList() {
      if (this.constDict.country_type_list) {
        return this.constDict.country_type_list.filter((option) => {
          // 英美咨询，则附加亚洲地区
          if (this.searchData.roleid === 124) {
            return this.searchData.roleid === option.pid || option.id === 2073;
          }
          // 日本咨询/前程咨询，则附日本国家
          if (this.searchData.roleid === 20 || this.searchData.roleid === 43) {
            return this.searchData.roleid === option.pid || option.id === 2137;
          }
          return this.searchData.roleid === option.pid;
        });
      }
      return [];
    },
    optionCountryList() {
      if (this.constDict.country_list) {
        return this.constDict.country_list.filter((option) => {
          return this.searchData.country_type === option.pid;
        });
      }
      return [];
    }
  },
};

</script>

<style scoped>
.searchForm *{
  padding: 5px;
}
.blue {
  color: #409EFF;
}
.channel-list2020 .list-title {
  background: #01142d;
  line-height: 40px;
  color: #fff;
  text-align: center;
}
.channel-list2020 .channel-list-level {
  line-height: 40px;
}
.channel-list2020 .channel-list-level:hover {
  background: #e6ebf6;
}
.channel-list2020 .channel-list-level1 .ib{
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.channel-list2020 .channel-list-level1 .ib span{
  padding-left: 30px;
}
.channel-list2020 .channel-list-level span:nth-of-type(1) i{
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  border-top: 6px solid red;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  transition: all linear 0.2s;
}
.channel-list2020 .channel-list-level span:nth-of-type(1) i.active{
  transform: translateY(-50%) rotate(180deg);
}
.channel-list2020 .channel-list-level2 {
  background: #eff2f9;
  color: #000;
}
.channel-list2020 .channel-list-level2 .ib{
  border-top: 1px solid #d9dfed;
  border-left: 1px solid #d9dfed;
}
.channel-list2020 .channel-list-level2 .ib:last-child{
  border-right: 1px solid #d9dfed;
}
.channel-list2020 .channel-list-level2 .ib span{
  padding-left: 50px;
}
.channel-list2020 .infinite-list-wrapper >>> ul li{
  background: #fff;
  color: red;
  border-radius: 0;
  margin-bottom: 0;
  padding: 0;
}
</style>
